
$(document).ready(function(){
$(".banner_slider .banner_list").slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 2000,
  slidesToShow: 1,
  adaptiveHeight: true,
});
 
$('.recent_video_main .video_list').slick({
  dots: true,
  infinite: true,
  appendArrows: $('.recent_video__arrows'),
  prevArrow: '<div class="arrow_left"></div>',
  nextArrow: '<div class="arrow_right"></div>',
  appendDots: $('.video__dots'),
       customPaging : function(slider, i) {
var thumb = $(slider.$slides[i]).data();

return (i + 1);
      },
   dotsClass: 'video__dots-list',
  speed: 300,
  centerMode: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
     {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        centerMode: false,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        centerMode: false,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
         centerMode: false,
        slidesToScroll: 1
      }
    }
  ]
});  

$('.featured_product_bg .product_inner').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
     {
      breakpoint: 1441,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
     {
      breakpoint: 1361,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});  

$('.reviews_inner .customer_list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});  


$('.slider-for').slick({
   autoplay: false,
    speed:700,
    mobileFirst: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    rows: 1,
    fade: true,
    swipeToSlide: true,
    infinite: false,
    focusOnSelect: true,
    pauseOnHover:false,
    arrows: false,
    dots: false,
    respondTo:'min',
    asNavFor: '.slider-nav',
    cssEase:'linear'
});
$('.slider-nav').slick({
   autoplay: false,
    speed:700,
    mobileFirst: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    rows: 2,
    swipeToSlide: false,
    infinite: false,
    focusOnSelect: true,
    pauseOnHover:false,
    arrows: false,
    dots: true,
    respondTo:'min',
    asNavFor: '.slider-for',
    cssEase:'linear'
  //   responsive: [
  //   {
  //     breakpoint: 1024,
  //     settings: {
  //       slidesToShow: 3,
  //       slidesToScroll: 1,
  //       dots: true
  //     }
  //   },
  // {
  //     breakpoint: 991,
  //     settings: {
  //       slidesToShow: 2,
  //       slidesToScroll: 1,
  //       dots: true
  //     }
  //   },
  //   {
  //     breakpoint: 768,
  //     settings: {
  //       slidesToShow: 3,
  //       slidesToScroll: 1,
  //       dots: true
  //     }
  //   },
  //   {
  //     breakpoint: 421,
  //     settings: {
  //       slidesToShow: 2,
  //       slidesToScroll: 1
  //     }
  //   }
  // ]
});
  $('.slick').slick();
    var $parent = $(".slider-for");
    var $nav = $(".slider-nav");
    var $content = $nav.find("div");
    var killit = false;
    $content.on("click", function(e){
      if( !killit ) {
          e.stopPropagation();
        $('.thumbnail_list').removeClass('active-slider');
          var idx = $(this).data("thumb");
          $(this).addClass('active-slider');
          $parent.slick("goTo", idx-1);
      }
    });
    $nav
    .on("beforeChange", function() {
        killit = true;
    }).on("afterChange", function() {
        killit = false;
    });
});